import { toast } from 'react-toastify';

const POSITION = 'top-center';
const AUTO_CLOSE_DELAY = 5000;

// eslint-disable-next-line import/prefer-default-export
export const showToastMessage = (message, type = 'error') => {
  if (!message) {
    return null;
  }

  const commonOptions = {
    position: POSITION,
    autoClose: AUTO_CLOSE_DELAY,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    closeButton: false
  };

  switch (type) {
    case 'success':
    case true:
      return toast.success(message, {
        ...commonOptions,
        style: {
          background: '#CDEDE5',
          border: '1px solid #A3D9CC',
          color: '#136753',
          borderRadius: '8px',
          maxHeight: '24px',
          fontFamily: 'Sofia Pro'
        },
        className: 'custom-toast',
        icon: (
          <img
            src="/img/flightpath/icons/completed.svg"
            alt="completed icon"
          />
        )
      });
    case 'error_old':
      return toast.error(message, {
        ...commonOptions,
        theme: 'colored'
      });
    case 'error':
    default:
      return toast.info(message, {
        ...commonOptions,
        icon: (
          <></>
        ),
        className: 'custom-toast',
        style: {
          background: '#FFF5F5',
          border: '1px solid #DC2626',
          borderRadius: '8px',
          color: '#DC2626',
          maxHeight: '94px',
          fontFamily: 'Sofia Pro'
        }
      });
  }
};
